import React from 'react';
import { MousePointer2, Square, Hexagon, Minus, Ruler, Type, Shapes, Eraser } from 'lucide-react';
import { useEditorStore } from '../../store/editorStore';
import type { ToolId } from '../../types';

const TOOLS: { id: ToolId; icon: React.ElementType; shortcut: string }[] = [
  { id: 'select', icon: MousePointer2, shortcut: 'V' },
  { id: 'room', icon: Square, shortcut: 'R' },
  { id: 'polygon', icon: Hexagon, shortcut: 'P' },
  { id: 'wall', icon: Minus, shortcut: 'W' },
  { id: 'dimension', icon: Ruler, shortcut: 'D' },
  { id: 'text', icon: Type, shortcut: 'T' },
  { id: 'symbol', icon: Shapes, shortcut: 'S' },
  { id: 'eraser', icon: Eraser, shortcut: 'E' },
];

const LeftToolbar: React.FC = () => {
  const { activeTool, setActiveTool } = useEditorStore();

  return (
    <div className="flex flex-col py-2 gap-1">
      {TOOLS.map(({ id, icon: Icon, shortcut }) => (
        <button
          key={id}
          onClick={() => setActiveTool(id)}
          className={`flex flex-col items-center justify-center w-12 h-12 rounded-lg transition-all ${
            activeTool === id ? 'bg-[#FF4C4C]/20' : 'hover:bg-white/5'
          }`}
          style={{
            color: activeTool === id ? '#FF4C4C' : '#8888aa',
            boxShadow: activeTool === id ? '0 0 12px rgba(255,76,76,0.4)' : undefined,
          }}
          title={`${id} (${shortcut})`}
        >
          <Icon size={22} strokeWidth={2} />
          <span className="text-[9px] mt-0.5">{shortcut}</span>
        </button>
      ))}
    </div>
  );
};

export default LeftToolbar;
